export default __webpack_public_path__ + "static/media/lady-hand.097f269c.png";